var Curriculog = Curriculog || {};

Curriculog.RoleFlyoutView = (function ($, _, Backbone, RoleFlyoutView) {

	var RoleFlyoutView = Curriculog.CurriculogView.extend({
		initialize: function (options) {
			this.roles = options.roles;
			this.roleTypes = options.roleTypes;
			this.canDelete = options.canDelete;
			this.committees = options.committees;
			this.currentRoleID = options.currentRoleID;
			this.role = this.roles.get(this.currentRoleID);
      this.params = options.params;

			var sanitizedRoleModel = this.role.getSanitizedModel();

			this.flyoutTitle = new Curriculog.FlyoutTitleView({
				model: this.role,
				title: sanitizedRoleModel.get('name'),
        params: this.params
			});

	        this.manageRole = new Curriculog.ManageRolesBasicView({
	            roles: this.roles,
	            canDelete: this.canDelete,
	            roleTypes: this.roleTypes,
	            committees: this.committees,
	            currentRoleID: this.currentRoleID,
	        });

	        this.render();
		},

		render: function () {
			this.$el.append(this.flyoutTitle.el);
			this.$el.append(this.manageRole.el);
		},

		cleanup: function () {
			this.flyoutTitle.remove();
			this.manageRole.remove();
			this.remove();
		},
	});

	return RoleFlyoutView;

})($, _, Backbone, Curriculog.RoleFlyoutView || {});
